const { Core, Events, onBlazeLoad } = Global;

customElements.define('product-gallery-slider', class extends Core {
    propTypes = {
        'listen-variants': Boolean
    }

    elements = {
        slider: 'slideshow-blaze'
    }

    render() {
        if (this.prop('listen-variants')) {
            this.sub(Events.VARIANT_UPDATE, this._onVariantChange);
        }
        this.sub(Events.PRODUCT_GALLERY_SLIDE_CHANGE, this._changeSlide);
        onBlazeLoad(this._handleSlider.bind(this));

        // ── Arrow buttons ──
        this._currentIndex = 0;
        const prevBtn = this.querySelector('[aria-label="Previous image"]');
        const nextBtn = this.querySelector('[aria-label="Next image"]');

        if (prevBtn && nextBtn) {
            prevBtn.addEventListener('click', () => {
                const total = this._getTotal();
                if (!total) return;
                const newIndex = (this._currentIndex - 1 + total) % total;
                this._currentIndex = newIndex;
                this.pub(Events.PRODUCT_GALLERY_SLIDE_CHANGE, newIndex);
                this._changeSlide(newIndex);
            });

            nextBtn.addEventListener('click', () => {
                const total = this._getTotal();
                if (!total) return;
                const newIndex = (this._currentIndex + 1) % total;
                this._currentIndex = newIndex;
                this.pub(Events.PRODUCT_GALLERY_SLIDE_CHANGE, newIndex);
                this._changeSlide(newIndex);
            });
        }
    }

    _getTotal() {
        return this.querySelectorAll('[data-element="media"]').length;
    }

    _onVariantChange({ imageIndex }) {
        if(imageIndex >= 0) {
            this._currentIndex = imageIndex;
            this.pub(Events.PRODUCT_GALLERY_SLIDE_CHANGE, imageIndex);
            this._changeSlide(imageIndex);
        }
    }

    async _handleSlider() {
        await customElements.whenDefined(this.elements.slider);
        this.$('slider').slider.onSlide(this._handleSlideChange.bind(this));
    }

    _handleSlideChange(index) {
        this._currentIndex = index;
        this.pub(Events.PRODUCT_GALLERY_SLIDE_CHANGE, index);
    }

    _changeSlide(index) {
        this.$('slider')?.slideTo(index);
    }
});
